// Botones "+ Add" de la tienda (ficha y cajón del carrito): formularios con [data-bs-add-form].
// Delegación en document para que sigan funcionando cuando Horizon vuelve a pintar el cajón.
// Mismo contrato que product-form.js: CartLinesUpdateEvent con promesa + sections del cajón,
// así el cajón se abre y se actualiza. Sin JS, el formulario hace un POST normal a /cart/add.
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

document.addEventListener('submit', async (event) => {
  const form = event.target instanceof HTMLFormElement ? event.target.closest('form[data-bs-add-form]') : null;
  if (!form) return;
  event.preventDefault();

  const button = form.querySelector('button[type="submit"], [data-bs-protection-toggle]');
  if (!button || form.dataset.busy) return;
  form.dataset.busy = '1';
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');

  const formData = new FormData(form);
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el instanceof HTMLElement ? el.dataset.sectionId : '')
    .filter(Boolean);
  if (sectionIds.length) formData.append('sections', sectionIds.join(','));

  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(formData.get('id')), quantity: Number(formData.get('quantity')) || 1 }],
      promise: deferred.promise,
    })
  );

  const status = form.closest('[data-bs-add-scope]')?.querySelector('[data-bs-add-status]');

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    });
    const data = await response.json();
    const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const didError = Boolean(data.status);

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'bs-quick-add',
        sourceId: form.dataset.productId || '',
        itemCount: 1,
        productId: form.dataset.productId,
        sections: data.sections,
        didError,
      },
    });

    if (didError) {
      form.dispatchEvent(
        new CartErrorEvent({
          error: data.message || 'Add to cart failed',
          code: 'INVALID',
          detail: { description: data.description },
        })
      );
      if (status) status.textContent = data.description || data.message || '';
    } else if (status) {
      status.textContent = Theme.translations?.added || 'Added';
    }
  } catch (error) {
    deferred.reject(error);
  } finally {
    delete form.dataset.busy;
    if (button.isConnected) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }
});

// Protección de envío (snippets/bs-cart-protection.liquid): encender la añade con el formulario de arriba;
// apagar quita su línea con el mismo método que la papelera de Horizon, así el cajón se repinta igual.
const PROTECTION_OFF = 'bs-protection-off';
const PROTECTION_AUTO = 'bs-protection-auto';

const storage = {
  get: (key) => { try { return sessionStorage.getItem(key); } catch { return null; } },
  set: (key, value) => { try { sessionStorage.setItem(key, value); } catch { /* sin almacenamiento */ } },
};

function removeProtectionLine(element) {
  const line = Number(element.dataset.line);
  const items = element.closest('cart-items-component') || document.querySelector('cart-items-component');
  if (!line || !items || typeof items.onLineItemRemove !== 'function') return;
  items.onLineItemRemove(line);
}

document.addEventListener('change', (event) => {
  const toggle = event.target instanceof HTMLInputElement && event.target.matches('[data-bs-protection-toggle]') ? event.target : null;
  const form = toggle?.closest('form[data-bs-protection]');
  if (!toggle || !(form instanceof HTMLFormElement)) return;
  if (toggle.checked) {
    storage.set(PROTECTION_OFF, '');
    form.requestSubmit();
  } else {
    storage.set(PROTECTION_OFF, '1');
    toggle.disabled = true;
    removeProtectionLine(form);
  }
});

function checkProtection() {
  for (const orphan of document.querySelectorAll('[data-bs-protection-orphan]:not([data-done])')) {
    orphan.setAttribute('data-done', '');
    removeProtectionLine(orphan);
  }
  const auto = document.querySelector('form[data-bs-protection-auto]:not([data-done])');
  if (auto instanceof HTMLFormElement && !storage.get(PROTECTION_OFF) && !storage.get(PROTECTION_AUTO)) {
    auto.setAttribute('data-done', '');
    storage.set(PROTECTION_AUTO, '1');
    auto.requestSubmit();
  }
}

new MutationObserver(checkProtection).observe(document.documentElement, { childList: true, subtree: true });
checkProtection();
